import { useState } from "react";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Problem from "@/components/landing/Problem";
import HowItWorks from "@/components/landing/HowItWorks";
import Features from "@/components/landing/Features";
import Benefits from "@/components/landing/Benefits";
import Pricing from "@/components/landing/Pricing";
import Footer from "@/components/landing/Footer";
import PasswordGate from "@/components/landing/PasswordGate";

export default function LandingPage() {
  const [unlocked, setUnlocked] = useState(
    localStorage.getItem("aerobic_proposal_access") === "true"
  );

  if (!unlocked) {
    return <PasswordGate onUnlock={() => setUnlocked(true)} />;
  }

  return (
    <main className="overflow-x-hidden">
      <Navbar />
      <Hero />
      <Problem />
      <HowItWorks />
      <Features />
      <Benefits />
      <Pricing />
      <Footer />
    </main>
  );
}
